export const CustomEventNames = Object.freeze({
  crm: {
    activities: {
      reloadActivityHome: 'reloadActivityHomeData',
    },
    expirations: {
      reloadExpirationsHome: 'reloadExpirationsHomeData',
    },
    offerManagement: {
      reloadOfferManagementHome: 'reloadOfferManagementHomeData',
    },
  },
  lighting: {
    reloadConfigHome: 'reloadLightingConfigHomeData',
  },
  measurements: {
    reloadHome: 'reloadMeasurementsHomeData',
  },
  pricing: {
    reloadHome: 'reloadPricingHomeData',
  },
} as const);
